import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router'
import useCompanyHeader from '../../../common/category/useCompanyHeader'
import { Loading } from '../../../common/loading'
import ErrorCustom, { errorTypes } from '../../../errors/ErrorCustom'
import { SaveRoute } from '../../../layout/SaveRoute'
import { selectUserType } from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import { USER_TYPE } from '../../../utils/authorization'
import { Content } from './Content'
import './lang/i18n'
import { resetStore, selectIsRedirect404, selectLoading } from './store/slice'
import { getDomesticSearchDetail } from './store/thunk'

const DomesticSearchPreview = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectLoading)
  const isRedirect404 = useSelector(selectIsRedirect404)
  const { companyHeader, loading } = useCompanyHeader({ disableCallApi: true })
  const userType = useSelector(selectUserType)

  useEffect(() => {
    dispatch(getDomesticSearchDetail({ OrganizationId: params.organizationId }))
  }, [params.organizationId, locale])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  if (isLoading) {
    return <Loading />
  }

  if (isRedirect404) {
    return isRedirect404 === errorTypes.FORBIDDEN.statusCode ? (
      <ErrorCustom errorType={errorTypes.FORBIDDEN} />
    ) : (
      <ErrorCustom errorType={errorTypes.NOT_FOUND_ORGANIZATION_ID} />
    )
  }

  if (loading) {
    return <Loading />
  }

  if (userType.userTypeId === USER_TYPE.LITE && companyHeader.boughtReport) {
    return (
      <Navigate
        to={[
          COMPONENTS.companyAnalysis.components.summary.route,
          '?organizationId=' + params.organizationId,
        ].join('')}
        replace={true}
      />
    )
  }

  return (
    <SaveRoute>
      <Content />
    </SaveRoute>
  )
}

export default DomesticSearchPreview
